module.exports = __webpack_public_path__ + "static/img/Diamond3.907881f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Diamond3.svg
// module id = NICV
// module chunks = 35